module.exports = __webpack_public_path__ + "static/media/icon-giveaway.becb2ecb.svg";